import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import { connect } from 'react-redux';
import axios from '../../axios';
import { toolkitCategories , initialToolDetailsState} from '../../utils/categories';
import * as actionCreators from '../../modules/actions/index';
import * as url from '../../utils/url';
import {addToolStep, toolkitSteps, toolkitFields,staticTitles} from '../../utils/constants';
import {filterToolFocus} from '../../utils/filterToolData';
import {addToolDetailsInForm} from '../../utils/createRequestData';
import Steps from '../../components/Steps/Steps';
import LocationAndContact from "./Components/LocationAndContact/LocationAndContact";
import Info from './Components/Info/Info';
import Focus from './Components/Focus/Focus';
import PrivacySettings from './Components/PrivacySettings/PrivacySettings';
import ErrorMessage from '../../components/Message/ErrorMessage/ErrorMessage';
import pick from 'lodash/pick';
import Loading from '../../hoc/Loading/Loading';
import "./Toolkit.css";

class EditToolkit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diversityFocusOptions: [],
      relevantForOptions: [],
      updated_tool_fields:[]
    }
  }

  componentWillReceiveProps(nextProps) {
    const category = this.props.match.params.category; 
    if (nextProps.toolDetails.nextStep === addToolStep.preview) {
        this.props.history.replace(`/home/toolkit/${category}/preview`);
      } 
  }

  updateToolFields = val =>{
    let{updated_tool_fields}=this.state,
    {toolDetails}=this.props,
    res=[]

    if(updated_tool_fields && updated_tool_fields.length>0){
      res=[...updated_tool_fields]
    }
    
    if(toolDetails && toolDetails.updated_tool_fields && toolDetails.updated_tool_fields.length>0){
      res = [...res, ...toolDetails.updated_tool_fields]
    }

    if(res.indexOf(val)==-1){
      // updated_tool_fields = [val, ...res]
      res = [val,...res]
      this.setState({updated_tool_fields:res})
    }
  }

  componentWillMount() {  
  }


  unique_tool_update=(arr)=>{
   return arr.filter((item, pos) => arr.indexOf(item) === pos)
  }


  handle_tool_update =()=>{
    let{updated_tool_fields}=this.state
    let{toolDetails}=this.props, res =[]
   
    if(toolDetails && toolDetails.updated_tool_fields){
      res = [ ...toolDetails.updated_tool_fields]
    } 
    if(updated_tool_fields &&updated_tool_fields.length>0){
      res=[...res, ...updated_tool_fields]
    }

    return res
  }

  
  componentDidMount() { 
    const location = this.props.history.location;
    // Listen for changes to the current location.
    const category = this.props.match.params.category;

    this.getToolFocusOptions();
  }
  
  handleToolInfoCompleted = (info) => {
    let res =[], updated_tool_fields
    res = this.handle_tool_update()
   
    if(res && res.length>0){
      updated_tool_fields = this.unique_tool_update(res)
      info= {...info, updated_tool_fields}
    }
    
     this.props.onToolInfoCompleted({ nextStep: addToolStep.focus, ...info});
  };

  handleToolFocusCompleted = (focus) => {
    let res =[], {updated_tool_fields}=this.state
    res = this.handle_tool_update()

    if(res && res.length>0){
      updated_tool_fields = this.unique_tool_update(res)
      focus= {...focus, updated_tool_fields}
    }
     
    this.props.onToolInfoCompleted({nextStep: addToolStep.locationAndContact, ...focus, });
  };

  handleToolLocationAndContactCompleted = (locationAndContact) => {
    let res =[], {updated_tool_fields}=this.state
    res = this.handle_tool_update()

    if(res && res.length>0){
      updated_tool_fields = this.unique_tool_update(res)
      locationAndContact = {...locationAndContact , updated_tool_fields }
    }
    
    this.props.onToolInfoCompleted({nextStep: addToolStep.privacy, ...locationAndContact });
  };

  handleToolPrivacySettingsCompleted = (privacy) => {
    let res =[], {updated_tool_fields}=this.state
    res = this.handle_tool_update()

    if(res && res.length>0){
      updated_tool_fields = this.unique_tool_update(res)
      privacy = {...privacy , updated_tool_fields }
    }

    this.props.onToolInfoCompleted({nextStep: addToolStep.privacy, ...privacy, });
    this.handleEditTool({...this.props.toolDetails, ...privacy , isPrivacySettingsChanged: false});
  };

  handleToolShowPreviewTool = (privacy) => {
    console.log('edit/preview----', this.props, '------',this.state)
    this.props.onToolPrivacySettingsCompleted({nextStep: addToolStep.preview, ...privacy});
  };

  handleEditTool = (toolDetails) => {
  
    let that = this
    let editToolDetails = toolDetails;
    let{updated_tool_fields}=this.state
    console.log("editToolDetails",editToolDetails)
    let formData = new FormData();
    formData = addToolDetailsInForm(formData, editToolDetails);
    formData.append('u_fields', JSON.stringify(updated_tool_fields))
    formData.append('updated', JSON.stringify(toolDetails.currentTool.updated_tool_fields))

    formData.append('updated_tool_fields', toolDetails.updated_tool_fields)
    formData.append('payload', JSON.stringify(editToolDetails))
    
    Array.from(editToolDetails.attachments).forEach(itm => {
      formData.append('attachments', itm.file);
    })

    if(editToolDetails.bannerImg && editToolDetails.bannerImg.file && editToolDetails.bannerImg.isUploaded ){
      Array.from([editToolDetails.bannerImg]).forEach(itm => {
        formData.append('bannerImg', itm.file);
      })
    }

    axios.put(url.editTool(toolDetails._id), formData).then(response => {
      const category = this.props.match.params.category;
      console.log(response, category)
      that.props.onEditToolSuccess({...initialToolDetailsState, category: this.props.toolDetails.category, isPrivacySettingsChanged: false});
      that.props.history.replace(`/home/toolkit/${category}/tool/${response.data._id}`);

    }).catch(err=> console.log('err', err))
  }

  handleGoBack = () => {
    let previousStep = '';
    if(this.props.toolDetails.nextStep === addToolStep.focus) {
       previousStep = addToolStep.info;
      } else if(this.props.toolDetails.nextStep === addToolStep.locationAndContact) {
       previousStep = addToolStep.focus;
      } else if(this.props.toolDetails.nextStep === addToolStep.privacy) {
       previousStep = addToolStep.locationAndContact;
      }
    this.props.onGoBackPressed({nextStep: previousStep});
  }

  getToolFocusOptions = () => {
    axios.get(url.getAllFoucsList).then(response => {
      let { diversityFocusOptions, relevantForOptions } = filterToolFocus(response.data);
      this.setState({ diversityFocusOptions, relevantForOptions });
    }).catch(error => {
      console.log(error);
    });
  }

  navigateToToolDetails = () => {
    const {category} = this.props.match.params;
    const {_id} = this.props.toolDetails;
    console.log('navigate---', this.props)

    this.props.onLeaveEditTool();
    this.props.history.push(`/home/toolkit/${category}/tool/${_id}`);
  }

  render() {
    let {toolDetails} = {...this.props};
    let {error, errorMessage, diversityFocusOptions, relevantForOptions} = {...this.state};
    let addToolCurrentStep = null;
    let currentToolStep = 0;
    let errorMessageView = null;
    if(error) {
      errorMessageView = <ErrorMessage message={errorMessage}/>
    }
    if(this.props.toolDetails.nextStep === addToolStep.info) {
      currentToolStep = 1;
      addToolCurrentStep = <Info updateToolFields={this.updateToolFields}
      tool_status={'Edit'} onCompleted={this.handleToolInfoCompleted} goBackToPreviousStep={this.handleGoBack} toolDetails={this.props.toolDetails}/> 
    } else if(this.props.toolDetails.nextStep === addToolStep.focus) {
      currentToolStep = 2;
      addToolCurrentStep = <Focus tool_status={'Edit'}  updateToolFields={this.updateToolFields} onCompleted={this.handleToolFocusCompleted} goBackToPreviousStep={this.handleGoBack} diversityFocusOptions={diversityFocusOptions} relevantForOptions={relevantForOptions} {...this.props} />
    } else if(this.props.toolDetails.nextStep === addToolStep.locationAndContact) {
      currentToolStep = 3;
      addToolCurrentStep = <LocationAndContact tool_status={'Edit'} 
      updateToolFields={this.updateToolFields} onCompleted={this.handleToolLocationAndContactCompleted} goBackToPreviousStep={this.handleGoBack} {...this.props}/> 
    } else if(this.props.toolDetails.nextStep === addToolStep.privacy) {
      currentToolStep = 4;  
      addToolCurrentStep = <PrivacySettings tool_status={'Edit'}  
      updateToolFields={this.updateToolFields} onCompleted={this.handleToolPrivacySettingsCompleted} 
      showPreviewTool={this.handleToolShowPreviewTool} goBackToPreviousStep={this.handleGoBack} {...this.props}/> 
    }
    return (
      <div className="edit_toolkit_page_container col-md-11 col-sm-11 col-lg-11">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a className="add-tool-link" onClick={this.navigateToToolDetails}>{toolDetails.name}</a>
            </BreadcrumbItem>
            <BreadcrumbItem active>Edit {staticTitles.toolkit_sm}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div>
          <h3 className="add-category-title mt30">Edit {toolDetails.category}</h3>
        </div>
        <Steps steps={toolkitSteps} currentStep={currentToolStep}/>
        {errorMessageView}
        {addToolCurrentStep}
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    toolDetails : state.toolkit.toolDetails,
    user: state.user.profile
	}
}
const mapDispatchToProps = dispatch => {
	return {
    onToolEditLoaded: (data) => dispatch(actionCreators.editToolLoaded(data)),
    onToolInfoCompleted: (data) => dispatch(actionCreators.toolInfoCompleted(data)),
    onToolFocusCompleted: (data) => dispatch(actionCreators.toolFocusCompleted(data)),
    onToolLocationAndContactCompleted: (data) => dispatch(actionCreators.toolLocationAndContactCompleted(data)),
    onToolPrivacySettingsCompleted: (data) => dispatch(actionCreators.toolPrivacySettingsCompleted(data)),
    onGoBackPressed: (data) => dispatch(actionCreators.toolGoBackPressed(data)),
    onEditToolSuccess: (data) => dispatch(actionCreators.editToolSuccess(data)),
    onLeaveEditTool: () => dispatch(actionCreators.leaveEditTool())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading(EditToolkit, axios));
